// import  { createContext, useContext, useState } from "react";

// const DashboardContext = createContext();

// export const DashboardProvider = ({ children }) => {
//   const [balance, setBalance] = useState(0);
//   const [code  , setCode]=useState('');
//   const [link , setLink]=useState('')

//   return (
//     <DashboardContext.Provider value={{ balance, setBalance ,code , setCode , link , setLink }}>
//       {children}
//     </DashboardContext.Provider>
//   );
// };




import { createContext, useContext, useState, useEffect } from "react";
import { getDashboardData } from "../services/dashboardService";

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {

  const [dashboardData  ,setdashboardData]=useState({});
  const [balance, setBalance] = useState(0);
  const [code, setCode] = useState("");
  const [link, setLink] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError(null);

      const apiResult = await getDashboardData();

      // Normalise API shape:
      // - If backend returns { status, message, data: { ...actualFields } }
      //   use the nested data object.
      // - If backend returns the fields directly ({ totalEarnings, ... }), use it as-is.
      const normalizedData =
        apiResult &&
        typeof apiResult === "object" &&
        apiResult.data &&
        typeof apiResult.data === "object"
          ? apiResult.data
          : apiResult || {};

      setdashboardData(normalizedData);
      setBalance(normalizedData?.totalEarnings || 0);
      setCode(normalizedData?.IBreferralCode || '');
      setLink(normalizedData?.ibReferralLink || '');

    } catch (err) {
      setError(err.message || "Failed to load dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return (
    <DashboardContext.Provider
      value={{
        dashboardData,
        balance,
        code,
        link,
        loading,
        error,
        refreshDashboard: fetchDashboard,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => useContext(DashboardContext);